import ReactDOM from 'react-dom';
import React from 'react';
import {App} from './layout/App';
import './global.css';

ReactDOM.render(<App />, document.getElementById('root'));
